import type { MutationSettings } from '@customTypes/index';
import { useMutation } from '@tanstack/react-query';

import type { DeleteVideoItemParams } from '@/shared/api/requests/video/delete-video-item/request';
import { deleteVideoItem } from '@/shared/api/requests/video/delete-video-item/request';

export const useDeleteVideoItemMutation = (
  settings?: MutationSettings<DeleteVideoItemParams, typeof deleteVideoItem>
) =>
  useMutation({
    mutationKey: ['DeleteVideoItem'],
    mutationFn: ({ params, config }) =>
      deleteVideoItem({
        params,
        config
      }),
    ...settings?.options
  });
